"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "toano": {
    "2006efb7": [{
      "hkey": "47152398",
      "slug": "toano",
      "name": "Toano",
      "primary": true,
      "skipSearch": false
    }],
    "cerre-marabino": [{
      "hkey": "47152398",
      "slug": "toano",
      "name": "Toano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f584ad42": [{
      "hkey": "eabf2e9b",
      "slug": "monzone-villa-bonicelli",
      "name": "Monzone-Villa Bonicelli",
      "primary": true,
      "skipSearch": false
    }],
    "monzone": [{
      "hkey": "eabf2e9b",
      "slug": "monzone-villa-bonicelli",
      "name": "Monzone-Villa Bonicelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;